import React, { useContext } from "react";
import { NavLink as Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { ThemeContext } from "../../context/ThemeStore";

const schedule = import.meta.env.VITE_SCHEDULE_PDF;

const BottomNav = () => {
  const { isDarkTheme } = useContext(ThemeContext);
  const packDetails = useSelector((state) => state.pack.recentPack);
  const packId = localStorage.getItem("selectedPackId");
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bottom-navbar d-md-none py-0" id="bottomNav">
        <div className="container-fluid">
          <ul className="navbar-nav bottom-navbar-navbar-nav me-lg-auto row mx-0">
            <li className="col-3 nav-item text-center">
              <Link
                className={({ isActive }) =>
                  `nav-link px-0 ${isActive ? (isDarkTheme ? "mobile-nav-active" : "mobile-nav-active-dark") : ""}`
                }
                to="/v2/home"
              >
                <i className="fe fe-home"></i>
                <span className="d-md-none" style={{ fontSize: "12px" }}>
                  Home
                </span>
              </Link>
            </li>
            <li className="col-3 nav-item text-center">
              <Link
                className={({ isActive }) =>
                  `nav-link px-0 ${isActive ? (isDarkTheme ? "mobile-nav-active" : "mobile-nav-active-dark") : ""}`
                }
                to="/test-series"
              >
                <i className="fe fe-book"></i>
                <span className="d-md-none" style={{ fontSize: "12px" }}>
                  Packs
                </span>
              </Link>
            </li>
            <li className="col-3 nav-item text-center">
              <Link
                className={({ isActive }) =>
                  `nav-link px-0 ${isActive ? (isDarkTheme ? "mobile-nav-active" : "mobile-nav-active-dark") : ""}`
                }
                to={`/v2/dash?packId=${packId}`}
              >
                <i className="fe fe-clipboard"></i>
                <span className="d-md-none" style={{ fontSize: "12px" }}>
                  Tests
                </span>
              </Link>
            </li>
            <li className="col-3 nav-item text-center">
              <Link
                strict="true"
                to="/account/"
                className={({ isActive }) =>
                  `nav-link px-0 ${isActive ? (isDarkTheme ? "mobile-nav-active" : "mobile-nav-active-dark") : ""}`
                }
              >
                <i className="fe fe-user"></i>
                <span className="d-md-none" style={{ fontSize: "12px" }}>
                  Profile
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
